var app = window.app || {}
app.width = window.innerWidth
app.height = window.innerHeight
app.setSizeCallback = undefined
app.setSize = function () {
  var fun = function () {
    var aspect = 0.7;
    var el_app = document.querySelector('.app');
    app.width = window.innerWidth;
    app.height = window.innerHeight;
    if (app.width / app.height > aspect) {
      app.width = app.height * aspect;
    }
    if (el_app) {
      el_app.style.width = app.width + 'px';
      // el_app.style.height = app.height + 'px';
      el_app.style.fontSize = app.width / 320 * 12 + 'px'
    }
    typeof (app.setSizeCallback) == 'function' && app.setSizeCallback()
  }
  fun()
}
window.addEventListener('resize', app.setSize, false)

window.onload = function () {
  app.setSize()
}